<template>
  <div class="order-confirm-reject-product">
    <div class="reject-header">
      <div class="header-left">
        <s-checkbox class="checkbox" :value="innerValue ? true : false" @input="changeCheckbox"></s-checkbox>
        <div class="header-title">拒签无忧</div>
        <div class="recommend-box">
          <img src="https://o.666visa.cn/static/ssqpeer/order/confirm/reject-icon-safe.png" class="reject-show-title-icon" />
          80%用户选择，客户出行更放心
        </div>
      </div>

      <div class="header-right">
         <!-- 评论 -->
        <scroll-up-animation :list="productDetail.reject_product_show_list" class="comment-list" v-if="productDetail.reject_product_show_list && productDetail.reject_product_show_list.length">
          <template  v-slot="{list}">
            <div class="comment-item" v-for="(comment,ind) in list" :key="ind">
              <img :src="comment.avatar" alt="" class="comment-img">
              <div class="comment-person-name">深圳***旅行社</div>
              <div class="comment-content">{{ comment.text }}</div>
            </div>
          </template>
        </scroll-up-animation>
      </div>

    </div>


    <div class="reject-product-card-box">
      <div class="reject-product-list">
        <div :class="['reject-product-card', innerValue === item.reject_product_id ? 'active' : '']" v-for="item in productDetail.reject_product_set" :key="item.reject_product_id" @click="selectedRejectProduct(item.reject_product_id)">
          <div :class="['card-shield', item.ratio == getMaxRadio ? 'green-card-shield' : 'orange-card-shield']"></div>
          <div class="card-title" :title="item.reject_product_name">{{ item.reject_product_name }}</div>
          <div class="card-content">
            <div class="card-content-top">
              <div class="content-ratio">
                拒签赔<span class="green-text">{{ item.ratio }}%</span>
              </div>
              <div class="content-money">最高赔
                <span class="green-text">{{ getReturnPrice(item) }}</span>
                元
              </div>
            </div>

            <div class="content-pay-price">
              <base-price-text
                color="#2F333D"
                :price="item.sell_price"
                :styleOption="{
                  currency: 'font-size: 16px;line-height:18px;margin-right: 2px;',
                  integer: 'font-size: 26px;line-height:24px;',
                  decimal: 'font-size: 20px;',
                }"
              >
                <template #right><span style="font-size: 14px;line-height:15px;margin-right: 2px;">/人</span></template>
              </base-price-text>
            </div>
          </div>

          <div class="active-directore"></div>

          <div :class="['card-type', item.ratio == getMaxRadio ? 'green' : 'orange']" v-if="item.label">
            {{ item.label }}
          </div>
        </div>

        <div :class="['reject-product-card', !innerValue ? 'active' : '']" @click="selectedRejectProduct()">
          <div class="card-shield gray-card-shield"></div>
          <div class="card-title">无保障</div>
          <div class="card-content">
            <div class="card-content-top">
              <div class="content-ratio">拒签无退款</div>
              <div class="content-money red-text">0赔付</div>
            </div>
          </div>
          <div class="active-directore"></div>
        </div>
      </div>

      <div class="reject-product-price">
        <confirm-module-price-text
          :price="rejectProductPrice / order.applicant.length"
          :length="order.applicant.length"
        ></confirm-module-price-text>
      </div>
      
    </div>

    <div class="reject-product-tips">
      购买拒签无忧服务需理解并同意<span class="primary-key" @click="showRejectProductRules">须知声明</span>
      <span class="tips-icon" @click="showRejectProductRules"></span>
    </div>

  </div>
</template>
<script>
import NoticeModal from '@/components/common/modals/notice-modal/notice-modal';
import scrollUpAnimation from '@/components/common/animation/scroll-up-animation.vue';
import sCheckbox from '../../../components/form/s-checkbox';
import ConfirmModulePriceText from './base/confirm-module-price-text.vue';
import BasePriceText from './base/base-price-text.vue';

export default {
  name: '',
  components: {
    sCheckbox,
    scrollUpAnimation,
    ConfirmModulePriceText,
    BasePriceText,
  },
  props: {
    value: {
      type: [String, Number],
    },
    // 订单
    order: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    productDetail: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    // 优惠券减免金额
    couponReducePrice: {
      type: Number,
      default: 0,
    },
    rejectProductPrice: Number, // 拒签无忧的价格
  },
  data() {
    return {
      textImage: 'https://o.666visa.cn/static/ssqpeer/homepage/icon-more-blue.png',
    };
  },
  computed: {
    innerValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    // 计算出最具性价比的商品
    getMaxRadio() {
      if (!this.productDetail.reject_product_set) return;
      const returnPrinceList = this.productDetail.reject_product_set.map(item => item.ratio);
      return Math.max.apply(null, returnPrinceList);
    }, 
  },
  created() {
    // 初始值赋予
    if (this.productDetail.reject_product_set && this.productDetail.reject_product_set.length) {
      // 后台勾选了默认选中的
      const isDefaultSelectItem = this.productDetail.reject_product_set.find(item => item.is_selected);
      if (this.order.visa_reject_product_id && this.productDetail.reject_product_set.find(item => item.reject_product_id === this.order.visa_reject_product_id)) {
        // 如果订单里已经选中了，则判断在列表里则选中
        this.innerValue = this.order.visa_reject_product_id;
      } else if (isDefaultSelectItem) {
        // 否则如果后台选择了默认选择，这里选中
        this.innerValue = isDefaultSelectItem.reject_product_id;
      }
    }
  },
  methods: {
    // 获取赔付最高价格
    getReturnPrice(rejectProduct) {
      // 有特价用特价
      if (this.order.special_price) {
        const resultPrice = this.order.special_price * rejectProduct.ratio / 100 / 100;
        return (Math.floor(resultPrice * 100) / 100).toFixed(2);
      }
      if (!this.order.applicant[0] || !this.order.applicant[0].sell_price) return 0;

      // 当前商品价格
      let productPrice = this.order.applicant[0].sell_price;

      // 使用过优惠券
      if (this.couponReducePrice) {
        // 单个人分到的优惠券价格
        const couponPrice = Math.floor(this.couponReducePrice / this.order.applicant.length);
        productPrice -= couponPrice;
      }

      // 优惠券比商品价格高的时候，会出现负数问题
      productPrice = productPrice > 0 ? productPrice : 0;

      // 直接截取
      const resultPrice = productPrice * rejectProduct.ratio / 100 / 100;
      return (Math.floor(resultPrice * 100) / 100).toFixed(2);
    },
    // 获取选中的赔付商品
    selectedRejectProduct(rejectProductId) {
      this.innerValue = rejectProductId || '';
    },
    // 显示规则
    showRejectProductRules() {
      NoticeModal.modal({
        title: '拒签无忧',
        message: this.productDetail.reject_product_rule,
        showCancelButton: false,
        showConfirmButton: false,
        isTextareaMessage: true,
        confirmButtonText: '我知道了',
        confirmMethod: () => {
        },
      });
    },
    changeCheckbox() {
      if (this.innerValue) {
        // 取消选中
        this.innerValue = '';
      } else if (this.productDetail.reject_product_set && this.productDetail.reject_product_set[0]) {
        // 选中，选中第一个
        this.innerValue = this.productDetail.reject_product_set[0].reject_product_id;
      }
    },
  },
};
</script>



<style lang="less" scoped>
.order-confirm-reject-product {
  background: #fff;
  margin: 20px 0;

  .reject-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 54px;
    padding: 0 24px;
    .header-left{
      display: flex;
      align-items: center;
      .checkbox{
        flex-shrink: 0;
      }
      .header-title{
        color: #2F333D;
        font-size: 20px;
        margin-left: 12px;
        font-weight: 600;
      }
      .recommend-box{
        display: flex;
        align-items: center;
        margin-left: 12px;
        color: #03B86F;
        font-size: 14px;
        line-height: 1;
        background: linear-gradient( 270deg, rgba(0,190,109,0) 0%, rgba(3,184,111,0.08) 100%);
        border-radius: 12px;
        height: 24px;
        .reject-show-title-icon{
          width: 16px;
          height: 18px;
          margin-right: 5px;
          margin-left: -3px;
        }

      }
    }

    .header-right{
      .comment-list {
        flex: 1;
        .comment-item {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          >img {
            width: 24px;
            height: 24px;
            border-radius: 50%;
          }
          .comment-person-name {
            margin-left: 8px;
            color: #2F333D;
            font-size: 14px;
            line-height: 1;
          }
          .comment-content {
            margin-left: 8px;
            color: #5F666E;
            font-size: 14px;
            line-height: 1;  
          }
        }
      }
    }
    
  }
  .reject-show-title {
    font-weight: 600;
    color: #03B86F;
    font-size: 20px;
    line-height: 22px;
    display: flex;
    align-items: center;
    background: linear-gradient(270deg, rgba(0,190,109,0) 0%, rgba(3,184,111,0.08) 100%);
    .reject-show-title-icon {
      width: 22px;
      height: 25px;
      margin-right: 8px;
    }
  }

  .reject-product-card-box {
    margin: 0 24px;
    background: #FAFBFC;
    padding: 20px 20px 16px 20px;
    display: flex;
    align-items: flex-start;
    .reject-product-list {
      flex-grow: 1;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 20px 16px;
      .reject-product-card {
        width: 165px;
        height: 218px;
        background: #fff;
        border-radius: 4px;
        border: 1px solid #DEE2E6;
        padding: 12px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 14px;
        position: relative;
        margin-bottom: 26px;
        cursor: pointer;
        &:nth-child(6n+1) {
          margin-left: 0;
        }
        >div {
          text-align: center;
        }
        .card-shield {
          width: 36px;
          height: 36px;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          &.gray-card-shield {
            background-image: url('../../../assets/imgs/ordering/gray-shield.png');
          }
          &.green-card-shield {
            background-image: url('../../../assets/imgs/ordering/green-shield.png');
          }
          &.orange-card-shield {
            background-image: url('../../../assets/imgs/ordering/orange-shield.png');
          }
        }
        .card-title {
          padding: 8px 0;
          font-size: 20px;
          font-weight: 600;
          color: #2F333D;
          border-bottom: 1px dashed #E0E0E0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 100%;
        }

        .card-content {
          margin-top: 16px;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          width: 100%;
          align-items: center;
          .card-content-top {
            color: #5F666E;
            .content-ratio {
              font-size: 14px;
            }
            .content-money {
              margin-top: 8px;
            }
          }

          .content-pay-price {
     
          }
        }

        .active-directore {
          width: 34px;
          height: 34px;
          background: url(../../../assets/imgs/ordering/selected-reject-product.png) no-repeat center / 100% 100%;
          opacity: 0;
          position: absolute;
          bottom: -1px; // 边框占1px
          right: -1px;
        }

        .card-type {
          height: 24px;
          font-size: 12px;
          padding: 8px 6px 4px 6px;
          color: #fff;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          position: absolute;
          bottom: -26px;
          &.green {
            background-image: url('../../../assets/imgs/ordering/green-bubble-input.png');
          }
          &.orange {
            background-image: url('../../../assets/imgs/ordering/orange-bubble-input.png');
          }
        }


        &.active {
          background: #F3F8FF;
          border: 1px solid #599FFF;
          .active-directore {
            opacity: 1;
          }
        }
      }
    }

    .reject-product-price{
      flex-shrink: 0;
      margin-left: 20px;
    }

    
    
  }

  .reject-product-tips {
    padding: 16px 24px;
    font-size: 14px;
    color: #91999F;
    line-height: 20px;
    display: flex;
    align-items: center;
    .primary-key {
      color: #599FFFFF;
      cursor: pointer;
    }
    .tips-icon{
      margin-left: 8px;
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 6px;
      background: url(../../../assets/imgs/ordering/tips.png) no-repeat center / 100% 100%;
      vertical-align: bottom;
    }
  }
  

  .red-text {
    color: #F43344;
  }
  .green-text {
    color: #03B86F;
  }

    
}
</style>



// WEBPACK FOOTER //
// src/pages/ordering/components/order-comfirm-reject-product.vue